import script from "./TripScoreDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TripScoreDialog.vue?vue&type=script&setup=true&lang=js"

import "./TripScoreDialog.vue?vue&type=style&index=0&id=aa37df7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa37df7e"]])

export default __exports__